// import { useStoreUser } from '@/store'
// import { refreshCookieToken } from '@/services/system'
// import { locationUrl } from '@/utils/util'
import type { GAxiosInstance, GAxiosOptions } from './typings'

// let retryRequests: any = []

/**
 * @author gx12358 2539306317@qq.com
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 * @param {*} instance
 * @param {*} config
 */
export const handleCode = async ({
}: {
  code: number,
  instance?: GAxiosInstance,
  config?: GAxiosOptions,
  msg?: string,
}) => {
  return true
}
